import React, { useState, useEffect } from "react";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import { useApiFetch } from "../utils/apiFetch";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";
import ConsultarPuertosSw from "./ConsultarPuertosSw";

function ReporteSw() {
    const { setModuloActual, setSubModuloActual, setElementoSeleccionado, logout } = useGlobal();
    const [arraySwitches, setArraySwitches] = useState([]);
    const [switchSeleccionado, setSwitchSeleccionado] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [confirmar, setConfirmar] = useState(false);  // Estado para controlar el mensaje de confirmación de eliminar
    const apiFetch = useApiFetch();
    const [vistaLocal, setVistaLocal] = useState("lista");

    // Función inicial para llenar el array que contendra los switches existentes: arraySwitches
    useEffect(() => {
        const fetchSwitches = async () => {
            setLoading(true);
            setError("");
            setSuccess("");

            try {
                const data = await apiFetch("consultar_switches.php", {
                    method: "GET"
                }, logout);

                if (data.status === "ok") {
                    setArraySwitches(data.data);
                    setSuccess("Registros encontrados.");
                } else {
                    setError(data.message || "Error al consultar switches.");
                    setTimeout(() => {
                        setModuloActual("Reportes");
                        setSubModuloActual(null);
                        setConfirmar(false);
                    }, 2000);
                }
            } catch (err) {
                setError("Error de conexión con el servidor: " + err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchSwitches(); // Ejecutar esta función
    }, []);

    const handleSelect = (id) => {
        setSwitchSeleccionado(id);
    };

    // Función para exportar uno o todos los registros
    const handleExportar = () => {
        let registrosParaExportar = [];

        if (switchSeleccionado) {
            const seleccionado = arraySwitches.find(sw => sw.nom_switch === switchSeleccionado);
            if (seleccionado) {
                registrosParaExportar = [seleccionado];  // Se asigna el objeto "seleccionado" 
            }
        } else {
            registrosParaExportar = arraySwitches;  // Se asigna todo el objeto de arrays al array de los registros para exportar
        }

        // Definiendo los encabezados de las columnas para el archivo a exportar
        const headers = [
            "Nombre",
            "Serie",
            "MAC",
            "Puertos",
            "Sede",
            "Edificio",
            "Nivel",
            "Descripción"
        ];

        // Convertir a CSV
        const csvRows = [];
        csvRows.push(headers.join(",")); // La primera fila serán los encabezados

        registrosParaExportar.forEach(sw => {   // Las filas siguientes seran los registros que esten en el array registrosParaExportar
            const row = [
                `"${sw.nom_switch}"`,
                `"${sw.serie_sw}"`,
                `"${sw.mac_sw}"`,
                `"${sw.puertos}"`,
                `"${sw.acronimo}"`,
                `"${sw.edificio}"`,
                `"${sw.nivel}"`,
                `"${sw.desc_switch}"`
            ];
            csvRows.push(row.join(","));
        });

        const csvString = csvRows.join("\n");

        // Crear archivo descargable
        const BOM = "\uFEFF"; // Marca de Orden de Bytes para UTF-8
        const blob = new Blob([BOM + csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "switches.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Función para desmarcar
    const handleDesmarcar = () => {
        setSwitchSeleccionado(null);
        setElementoSeleccionado(null);
    };

    // Función para modificar los puertos del switch seleccionado
    const handleConsultarPuertos = () => {
        if (!switchSeleccionado) {
            alert("Por favor selecciona un switch para consultar.");
            return;
        }

        const seleccionado = arraySwitches.find(sw => sw.nom_switch === switchSeleccionado);

        if (seleccionado) {
            setElementoSeleccionado(seleccionado);
            setVistaLocal("consultarPuertos");
            setConfirmar(false);
        }
    };

    // Función para exportar en PDF
    const handleExportarPDF = () => {
        let registrosParaExportar = [];

        if (switchSeleccionado) {
            const seleccionado = arraySwitches.find(sw => sw.nom_switch === switchSeleccionado);
            if (seleccionado) {
                registrosParaExportar = [seleccionado];
            }
        } else {
            registrosParaExportar = arraySwitches;
        }

        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text("Listado de Switches", 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla
        autoTable(doc, {
            startY: 50,
            head: [["Nombre", "Serie", "MAC", "Puertos", "Sede", "Edificio", "Nivel", "Descripción"]],
            body: registrosParaExportar.map(sw => [
                sw.nom_switch,
                sw.serie_sw,
                sw.mac_sw,
                sw.puertos,
                sw.acronimo,
                sw.edificio,
                sw.nivel,
                sw.desc_switch
            ])
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2025-2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        doc.save("switches.pdf");
    };

    // Función para resetear los mensajes después de un tiempo
    useEffect(() => {
        if (error || success) {
            const timer = setTimeout(() => {
                setError("");
                setSuccess("");
            }, 1500);

            return () => clearTimeout(timer); // Limpiar si cambia antes del tiempo
        }
    }, [error, success]);

    return (
        <div className="sesion-form">
            {loading && <p>Cargando switches...</p>}
            {error && <p className="error">{error}</p>}
            {/*{success && <p className="success">{success}</p>*/}

            {vistaLocal === "lista" && (
                <>
                    {arraySwitches.length > 0 && (
                        <>
                            <table className="tabla-estandar seleccion-unica">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Nombre</th>
                                        <th>Serie</th>
                                        <th>Sede</th>
                                        <th>Edificio</th>
                                        <th>Nivel</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {arraySwitches.map((sw, index) => (
                                        <tr key={index}>
                                            <td data-label="Seleccionar">
                                                <input
                                                    type="checkbox"
                                                    checked={switchSeleccionado === sw.nom_switch}
                                                    onChange={() => handleSelect(sw.nom_switch)}
                                                />
                                            </td>
                                            <td data-label="Nombre Switch">{sw.nom_switch}</td>
                                            <td data-label="Serie Switch">{sw.serie_sw}</td>
                                            <td data-label="Sede">{sw.acronimo}</td>
                                            <td data-label="Edificio">{sw.edificio}</td>
                                            <td data-label="Nivel">{sw.nivel}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className="form-buttons">
                                <button type="button" onClick={handleConsultarPuertos} disabled={!switchSeleccionado}>Consultar<br></br>puertos</button>
                                <button type="button" onClick={handleExportar}>Exportar<br></br>en CSV</button>
                                <button type="button" onClick={handleExportarPDF}>Exportar<br />en PDF</button>
                                <button type="button" onClick={handleDesmarcar} disabled={!switchSeleccionado}>Desmarcar</button>
                            </div>
                        </>
                    )}
                </>
            )}

            {vistaLocal === "consultarPuertos" && (
                <ConsultarPuertosSw />
            )}

        </div>
    );
}

export default ReporteSw;